import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import MODAL from '../../components/modal/modal';
import { ToastContainer, toast } from 'react-toastify';

const LIST_MODAL = ({ isOpen, onClose, onListChange }) => {

  const [inputValue, setInputValue] = useState({
    name: ""
  })

  const [userLists, setUserLists] = useState([]) // Store lists in state



  const handleOnChange = (e) => {
    const {name,value} = e.target
    //console.log(name,value)
    setInputValue({
      ...inputValue,
      [name]:value
    })
  }
  const handleSuccess = (message) =>
    toast.success(message, {
      position:"top-right"
    })
  const handleError = (error) =>
    toast.error(error, {
      position:"top-right"
    })

  const handleClose = () => {
    onClose();
  };

  const handleAddListSubmit = async(e) => {
    e.preventDefault()
    try {
      const {data} = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/lists/add-one-list`,
        {
          name: inputValue.name
        },
        {withCredentials:true}
      )
      const {success,message} = data
      if(success) {
        handleSuccess(message)
        getUserLists() // Refresh the list
      }else{
        handleError(data)
      }
    }catch(error){
      console.log(error)
    }
    setInputValue({
      ...inputValue,
      name:""
    })
  }

  const deleteThisList = async(deletedListID) => {
    try {
      const {data} = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/lists/delete-one-list`,
        {
          id: deletedListID
        },
        {withCredentials:true}
      )
      const {success,message} = data
      if(success) {
        handleSuccess(message)
        getUserLists()
        if(onListChange) onListChange()
      }else{
        handleError(data)
      }
    }catch(error){
      console.log(error)
    }
  }

  const getUserLists = async() => {
    try {
      if(!isOpen) {
        return false
      }
      const {data} = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/lists/get-user-lists`,
        {},
        {withCredentials:true}
      )
      const {message,userLists} = data
      setUserLists(userLists) // Store in state instead of innerHTML
    }catch(error){
      console.log(error)
    }
  }
  
  // Use useEffect to call getUserLists only when component mounts or passed_user_id changes
  useEffect(() => {
    getUserLists()
  }, [isOpen])

  return (
    <MODAL hasCloseBtn={true} isOpen={isOpen} onClose={handleClose}>
      <form onSubmit={handleAddListSubmit}>
        <div className="form-row">
          <label htmlFor="name">Add List</label>
          <input
            type="text"
            id="name"
            name="name"
            value={inputValue.name}
            onChange={handleOnChange}
          />
        </div>
        <div className="form-row">
          <button type="submit">Submit</button>
        </div>
      </form>
      <h3>Existing Lists</h3>
      <div id="list-list">
        {userLists?.map((list) => (
          <div key={list.id}>
            <button onClick={() => deleteThisList(list._id)}>Delete</button>
            {' | '}
            {list.name}
            {' | ' }
            
            {list.modelCount} {list.modelCount === 1 ? 'model' : 'models'}
          </div>
        ))}
      </div>
    </MODAL>
  );
};

export default LIST_MODAL;
